import React from 'react';
import { IconButton } from 'react-toolbox/lib/button';
import styles from 'components/IndeterminateCheckboxButton.css';

const IndeterminateCheckboxButton = props =>
  <IconButton theme={styles} icon="indeterminate_check_box" {...props} />;

export default IndeterminateCheckboxButton;
